import { render, staticRenderFns } from "./CampiMacchine.vue?vue&type=template&id=e31a528a&scoped=true&"
import script from "./CampiMacchine.vue?vue&type=script&lang=js&"
export * from "./CampiMacchine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31a528a",
  null
  
)

export default component.exports